import './index.scss'
$(".faq-list li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".answer").slideToggle();
})